<template>
  <div style="margin: 0 16px;">
    <div style="padding-bottom: 8px; display: flex; align-items: center; border-bottom: 1px solid #ededed; justify-content: space-between; width: 100%">

      <div style="width: 100%; margin-right: 24px; display: flex; flex-wrap: wrap;">
        <div class="input-item" style="width: 30%">
          <label>供应商</label>
          <el-select v-model="supplierId" placeholder="Select" class="select-item" filterable>
            <el-option v-for="item in supplierIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="input-item" style="width: 60%">
          <label>商品分类</label>
          <commodity-type-list title="" @confirm="getCommodityType($event)" :reSet="reSet" />
        </div>
        <div class="input-item" style="width: 30%">
          <label>品牌</label>
          <el-select v-model="brandId" placeholder="Select" class="select-item" filterable>
            <el-option v-for="item in brandIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>

        <div class="input-item" style="width: 60%">
          <label>商品名称</label>
<!--          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="12em"/>-->
          <el-input type="search" placeholder="请输入搜索内容" v-model="searchValue" style="width: 100%; flex:1" @input="getCommodityList">
            <template #prefix>
              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
            </template>
          </el-input>
          <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap; flex-shrink: 0">有限制</span></el-checkbox>
        </div>
      </div>


      <!--      <el-button  @click="getUserList">全部</el-button>-->

      <div style="display: flex; justify-content: space-between; align-items: center; ">
        <el-space direction="vertical">
          <el-button type="primary" @click="getCommodityList">查询</el-button>
          <el-button  @click="reSetParam">重置</el-button>
        </el-space>
      </div>

    </div>



    <div class="user-list" v-if="commodityList.length > 0">
      <div v-for="(item, index) of commodityList" :key="index" class="user-list-item" :class="[item.check?'active':'']" @click="select(item)">
        <div>
          <div v-if="item.commodityImgList && item.commodityImgList.length > 0" class="cursor" @click.stop="userImgList(item)">
            <el-image class="item-img" fit="cover" :src="item.commodityImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
          <div v-else>
            <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
        </div>
        <div class="text-list">
          <div class="text-list-item">
            <label>商品名称：</label>
            <span v-if="from == 1">{{item.name}}</span>
            <span v-else>{{item.commodityName}}</span>
          </div>
          <div class="text-list-item">
            <label>供货商：</label>
            <span>{{item.supplierName}}</span>
          </div>
          <div class="text-list-item">
            <label>商品品牌：</label>
            <span>{{item.brandName}}</span>
          </div>
          <div class="text-list-item">
            <label>商品规格：</label>
            <span>{{item.specification}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="margin-top: 100px">
      <el-empty image-size="100" description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import {getFormData } from "@/api/api"
import {listAllBrand, listAllSupplier, listForPurchase, getShopCommodityList} from "@/api/url";
import SearchComponents from "@/components/SearchComponents";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import commodityTypeList from "@/components/commodityTypeList";
export default {
  name: "UserListDialog",
  components: {SearchComponents, commodityTypeList},
  props: {
    value: Object
  },
  data() {
    return {
      shopId: this.value.shopId,
      commodityList: [],
      phone: '',

      from: this.value.from, //1、采购商品； 2、消费项目
      userId: this.value.userId,

      //搜索
      searchTypeList: [
        {label : '供应商', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      checked: true,

      supplierIdArray: [],
      supplierId: 0,

      brandIdArray: [],
      brandId: 0,

      limitState: false,

      commodityTypeId: 0,
      commoditySubTypeId: 0,
      reSet: false

    }
  },
  methods: {

    getCommodityType(e) {
      console.log(e)
      this.commodityTypeId = e[0]
      this.commoditySubTypeId = e[1]
      this.reSet = e[2]
    },

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.id,
          width: 908,
          from: 2,
          hideBtn: true
        },
        confirm: (result) => {
          // this.getPage()
        }
      })
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    reSetParam() {
      this.reSet = true
      this.searchValue = ''
      this.supplierId = 0
      this.brandId = 0
      this.limitState = false
      setTimeout(()=>{
        this.getCommodityList()
      }, 500)
    },


    getCommodityList() {
      let param = {}
      param['supplierId'] = this.supplierId
      param['brandId'] = this.brandId
      param['limitState'] = this.limitState?1:0
      param['commodityTypeId'] = this.commoditySubTypeId>0?this.commoditySubTypeId:this.commodityTypeId;
      param['searchValue'] = this.searchValue
      if(this.from == 2) {
        param['shopId'] = this.shopId
        param['userId'] = this.userId
      }
      getFormData(this.from == 2?getShopCommodityList:listForPurchase, param).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.commodityList = []
          this.commodityList = data.data
          this.commodityList.map(item => {
            item.check = false
          })
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


    select(item) {
      this.commodityList.map(e => {
        e.check = false
      })
      item.check = !item.check
      this.$emit('confirm', item)
    },

    getSupplierList() {
      getFormData(listAllSupplier).then(data=> {
        this.supplierIdArray = [
          {name: '不限', id: 0}
        ]
        this.supplierIdArray = this.supplierIdArray.concat(data.data)
      })
    },

    getBrandList() {
      getFormData(listAllBrand).then(data=> {
        this.brandIdArray = [
          {name: '不限', id: 0}
        ]
        this.brandIdArray = this.brandIdArray.concat(data.data)
      })
    },

  },
  mounted() {
    this.getCommodityList()
    this.getSupplierList()
    this.getBrandList()
  }
}
</script>

<style scoped>
.user-list {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.user-list-item {
  padding: 12px 16px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-bottom: 12px;
  /*background-color: #f6f6f6;*/
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 44%;
}
.active {
  border: 1px solid #409eff;
  /*background-color: #f5f7fa;*/
}
.user-list-item:hover {
  background-color: #f5f7fa;
}

.input-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  margin-right: 16px;
}
.input-item label {
  margin-right: 8px;
  width: 56px;
  text-align: right;
}

.item-img {
  width: 90px;
  height: 90px;
}

.text-list {
  /*display: flex;*/
  /*flex-wrap: wrap;*/
  margin-left: 16px;
  width: 100%;
  color: #606266;
  /*margin-top: 6px;*/
}

.text-list-item {
  width: 100%;
  margin: 2px 0;
  display: flex;
  align-items: center;
  line-height: 1.4;
  /*font-size: 13px;*/
}

.text-list-item label {
  width: 68px;
  /*text-align: right;*/
}


</style>
